import {
  createListenerMiddleware,
  addListener,
  type TypedStartListening,
  type TypedAddListener,
} from '@reduxjs/toolkit';
import { type RootState, type AppDispatch } from '../setup';

// Add one or more listener entries that look for specific actions.
// They may contain any sync or async logic, similar to thunks.
export const listenerMiddleware = createListenerMiddleware();

export type AppStartListening = TypedStartListening<RootState, AppDispatch>;

export const startAppListening =
  listenerMiddleware.startListening as AppStartListening;

export const addAppListener = addListener as TypedAddListener<
  RootState,
  AppDispatch
>;
